<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="deadlineFilter === 'all'"
            variant="outline-secondary"
            @click="updateDeadlineFilter('all')"
        >
            Toutes
        </b-button>
        <b-button
            :pressed="deadlineFilter === 'late'"
            variant="outline-danger"
            @click="updateDeadlineFilter('late')"
        >
            En retard
        </b-button>
        <b-button
            :pressed="deadlineFilter === 'soon'"
            variant="outline-warning"
            @click="updateDeadlineFilter('soon')"
        >
            A venir
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'DeadLineFilter',

    mixins: [DataUpdater],

    methods: {
        updateDeadlineFilter(value) {
            this.$store.commit('browsing/SET_DEADLINE_FILTER', value)
            if (this.updateAfterFiltering) {
                this.$emit('update-data')
                this.updateData()
            }
        },
    },

    computed: {
        ...mapState({
            deadlineFilter: (state) => state.browsing.deadlineFilter,
            activePage: (state) => state.browsing.pageName,
        }),

        updateAfterFiltering() {
            return (
                this.activePage !== 'ownTasks' &&
                this.activePage !== 'delegatedTasks'
            )
        },
    },
}
</script>

<style scoped></style>
